import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.mouseX
import com.github.chosamuel.kishibe.application.mouseY
import com.github.chosamuel.kishibe.application.renderer.Color
import com.github.chosamuel.kishibe.graphics.createMesh
import com.github.chosamuel.kishibe.math.Vector2
import org.khronos.webgl.WebGLRenderingContext as GL

class Graph {
    var nodes: MutableList<Point> = mutableListOf<Point>()
    //connections
    var cnx: MutableList<MutableList<Int>> = mutableListOf<MutableList<Int>>()

    fun update(cursor: Vector2){
        nodes.forEachIndexed { i, it ->
            //check
            val d = if(mouseMoved) Vector2(mouseX, mouseY).distanceTo(it.pos) else cursor.distanceTo(it.pos)
            it.on = d < 30
            //DIFFUSING COLOR
            val indices = cnx[i]
            var b = 0.0
            indices.forEach { ix ->
                b += nodes[ix].brightness
            }
            b /= indices.size.toDouble()
            it.brightness += (b - it.brightness)*0.1
            //toggle color if on
            if(it.on) it.brightness = 1.0
            it.col = Color(
                it.pigment.r * it.brightness,
                it.pigment.g * it.brightness,
                it.pigment.b * it.brightness
            )

            //DECAY
            it.brightness *= 0.99
        }
    }

}


fun Application.drawGraphAsLine(g: Graph) {
    val mesh = createMesh()
    g.nodes.forEachIndexed { i, it ->
        mesh.addVertex(it.pos)
        mesh.addColor(it.col)
        mesh.addIndex(i.toShort())
    }
    mesh.draw(GL.LINE_STRIP)
}